import {HTTP_METHODS} from '@/utils/constants/httpMethods'
import {toSafePathSegment, toSafeQueryString} from '@/utils/security/pathSafety'

export const PROMOTION_PRODUCT_SELECTION_CONFIG = {
  PRODUCT_DROPDOWN_LIST: (dropDownType = '') => ({
    endPoint: `dropdowns/${toSafePathSegment(dropDownType)}`,
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
  }),
  GTIN_ALL: (queryParams = {}) => {
    const queryString = toSafeQueryString(queryParams)

    return {
      endPoint: `gtin${queryString ? `?${queryString}` : '?'}`,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    }
  },
  GTIN_DETAILS: (gtinId = '', queryParams = {}) => {
    const queryString = toSafeQueryString(queryParams)

    return {
      endPoint: `gtin/${toSafePathSegment(gtinId)}${queryString ? `?${queryString}` : '?'}`,
      method: HTTP_METHODS.GET,
      baseUrlKey: 'inventoryApiUrl',
    }
  },
}
